var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"administration",class:_vm.classObject},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"client"},[_vm._v(_vm._s(_vm.$t('task.administration')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }